/* global $ */

const $togglers = $('.js-toggler');

const toggleContent = {
  initialize() {
    if ($togglers.length) {
      this.createEventListeners();
    }
  },

  createEventListeners() {
    $togglers.each((i, toggler) => {
      $(toggler).on('click', this.toggleText);
    });
  },

  toggleText(e) {
    const $toggler = $(e.currentTarget);
    const isExpanded = $toggler.attr('aria-expanded') === 'true';

    $toggler.text(isExpanded ? $toggler.data('collapsed-text') : $toggler.data('expanded-text'));
  },
};

export default toggleContent;
